module.exports = __webpack_public_path__ + "img/agreste_lado_sub.357ed9a4.png";